module.exports = __webpack_public_path__ + "img/communicator-meeting.b07a6d61.png";